<template>
  <div class="tab" :class="{ active }" @click="onClick(index)">
    <img class="icon" :src="icon" />
    <span>{{ txt }}</span>
  </div>
</template>

<script>
export default {
  name: 'Tab',
  props: {
    icon: String,
    txt: String,
    active: Boolean,
    index: Number,
    onClick: Function,
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';

.tab {
  border-bottom: 2px solid transparent;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  min-width: 75px;
  height: 42px;
  display: block;
  padding: 2px;
  margin: 0 18px;
  opacity: 0.5;
  transition: opacity 0.3s, border 0.3s;
  cursor: pointer;
  user-select: none;

  &.active {
    border-bottom-color: $sidebar-color;
    opacity: 1;
  }

  img {
    width: 20px;
    height: 20px;
    margin-right: 7px;
  }

  span {
    font-size: 14px;
    font-weight: 500;
  }
}
</style>
